export default __webpack_public_path__ + "static/media/footer.20dbbb10.png";